var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{class:{
      'panorama-slider-point': true,
      'panorama-slider-point--disabled': _vm.disabled
    },attrs:{"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[(_vm.left)?_c('path',{attrs:{"d":"M15 4.99951L9 11.9995L15 18.9995","stroke-linecap":"round"}}):_vm._e(),(_vm.right)?_c('path',{attrs:{"d":"M9 4.99951L15 11.9995L9 18.9995","stroke-linecap":"round"}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }